/** Adds a days/hours/minutes/seconds counter. Use as:
 * 
 *  <countdown-counter data-options='{
      "date": "1970-01-01T00:00:00+00:00"
    }'>
      <span class="countdown__element">
        <div class="countdown__time" data-countdown-days-time>00</div>
        <div class="countdown__metric"  data-countdown-days-metric>{{- day_plural -}}</div>
      </span>
      
      <span class="countdown__element">
        <div class="countdown__time" data-countdown-hours-time>00</div>
        <div class="countdown__metric"  data-countdown-hours-metric>{{- hour_plural -}}</div>
      </span>

      <span class="countdown__element">
        <div class="countdown__time" data-countdown-minutes-time>00</div>
        <div class="countdown__metric"  data-countdown-minutes-metric>{{- minute_plural -}}</div>
      </span>

      <span class="countdown__element">
        <div class="countdown__time" data-countdown-seconds-time>00</div>
        <div class="countdown__metric"  data-countdown-seconds-metric>{{- second_plural -}}</div>
      </span>
    </countdown-counter>
 */

class countDown extends HTMLElement {
  constructor() {
    super();

    this.countdownTime = this.querySelectorAll('.countdown__time');

    // Get the time elements
    this.daysTime = this.querySelector('[data-countdown-days-time]');
    this.hoursTime = this.querySelector('[data-countdown-hours-time]');
    this.minutesTime = this.querySelector('[data-countdown-minutes-time]');
    this.secondsTime = this.querySelector('[data-countdown-seconds-time]');

    // Get the metric elements
    this.daysMetric = this.querySelector('[data-countdown-days-metric]');
    this.hoursMetric = this.querySelector('[data-countdown-hours-metric]');
    this.minutesMetric = this.querySelector('[data-countdown-minutes-metric]');
    this.secondsMetric = this.querySelector('[data-countdown-seconds-metric]');

    // Calculate time
    this.seconds = 1;
    this.minutes = this.seconds * 60;
    this.hours = this.minutes * 60;
    this.days = this.hours * 24;

    // Set the default
    this.defaults = {
      date: "1970-01-01T00:00:00+00:00"
    };

    // Check if we have extra options on the HTML
    if (this && this.dataset && this.dataset.options) {
      const jsonOptions = JSON.parse(this.dataset.options);

      if (jsonOptions) {
        this.options = {
          ...this.defaults,
          ...jsonOptions
        }
      }
    }

    // Time metrics
    const translation = this.options.translations;
    this.daySingular = translation.day_singular;
    this.dayPlural = translation.day_plural;
    this.hourSingular = translation.hour_singular;
    this.hourPlural = translation.hour_plural;
    this.minuteSingular = translation.minute_singular;
    this.minutePlural = translation.minute_plural;
    this.secondSingular = translation.second_singular;
    this.secondPlural = translation.second_plural;

    // Target date time, timezone included
    this.timeTarget = new Date(this.options.date);
    
    // Init the counter
    this.initCounter();
  }

  initCounter() {
    // Check if timeTarget is set and is higher then the time we live in
    if (this.timeTarget && this.timeTarget > new Date()) {
      this.countdownTime.forEach(element => {
        element.classList.remove('invisible');
      });

      // Invoke counter every second
      this.renderCounter.bind(this)();
      this.timer = setInterval(this.renderCounter.bind(this), 1000);
    }
  }

  renderCounter() {
    // Get the current date from the user to work with
    const now = new Date();

    // Calculate the difference between the users time and now
    const difference = (this.timeTarget - now) / 1000

    // Calculate the countdown time
    const days = Math.floor(difference / this.days); // days
    const hours = Math.floor((difference % this.days) / this.hours); // hours
    const minutes = Math.floor((difference % this.hours) / this.minutes); // minutes
    const seconds = Math.floor((difference % this.minutes) / this.seconds); // seconds

    // Clear interval if the time left is lower or equal to 0
    if (difference <= 0) {
      // Clear the interval
      clearInterval(this.timer);
      return;
    }
    else {
      // Write the time left in html
      this.daysTime.innerHTML = days.toString().padStart(2, '0');
      this.hoursTime.innerHTML = hours.toString().padStart(2, '0');
      this.minutesTime.innerHTML = minutes.toString().padStart(2, '0');
      this.secondsTime.innerHTML = seconds.toString().padStart(2, '0');

      // Write the correct metric
      this.daysMetric.innerHTML = days != 1 ? this.dayPlural : this.daySingular;
      this.hoursMetric.innerHTML = hours != 1 ? this.hourPlural : this.hourSingular;
      this.minutesMetric.innerHTML = minutes != 1 ? this.minutePlural : this.minuteSingular;
      this.secondsMetric.innerHTML = seconds != 1 ? this.secondPlural : this.secondSingular;
      
    }
  }
}

if (!customElements.get('countdown-counter')) {
  customElements.define('countdown-counter', countDown);
}